import React from "react";
import {observer} from "mobx-react";
import {Alert, AlertTitle, Box, Grid, Link, Typography} from "@mui/material";
import {useApplication} from "../../ApplicationProvider";
import {useNavigatorFeature} from "../../useFeature";
import {useNavigate} from "react-router-dom";
import LayoutContentWrapper from "../../components/layout/LayoutContentWrapper";
import LayoutContentToolbar from "../../components/layout/LayoutContentToolbar";
import FormSection from "../../forms/FormSection";
import FormColumn from "../../forms/FormColumn";
import FormRow from "../../forms/FormRow";
import FormAutocompleteField from "../../components/fields/FormAutocompleteField";
import FormFileField from "../../components/fileUploadComponents/FormFileField";
import BudgetFeature from "./BudgetFeature";

function BudgetScreen() {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useNavigatorFeature(() => new BudgetFeature(application), navigator);

    const isFeatureReady = (feature) => {
        return feature && feature.loaded;
    };

    const sectionHeader = (title, templateHref) => (
        <Box display="flex" alignItems="center" gap={2} sx={{margin: '.8em 0'}}>
            <Typography variant="h3" sx={{fontSize: '1rem', margin: 0}}>{title}</Typography>
            <Link href={templateHref} download>Descargar template</Link>
        </Box>
    );

    const budgetContent = () => {
        const form = feature.form;
        return (
            <Box>
                <LayoutContentToolbar title="Presupuestos"/>
                <Box p={3} display="flex" flexDirection="column" gap={3}>
                    <Alert severity="warning">
                        <AlertTitle>Antes de subir el archivo</AlertTitle>
                        Asegurate de que el nombre de la hoja y los nombres de las columnas coincidan
                        exactamente con los del template. Si no, la importación va a fallar.
                    </Alert>

                    <FormSection title="Año del Presupuesto">
                        <FormColumn>
                            <FormRow>
                                <FormAutocompleteField
                                    label="Año"
                                    form={form}
                                    fieldName={"year"}
                                    options={feature.yearOptions()}
                                    clear={() => feature.clearYearSelection()}
                                />
                            </FormRow>
                        </FormColumn>
                    </FormSection>

                    <FormSection header={sectionHeader("Presupuesto de Ventas", "/templates/Template_Presupuesto_Tienda.xlsx")}>
                        <Grid container gap={10}>
                            <Grid item xs={10} sm={5}>
                                <FormFileField
                                    key="salesBudgetFile"
                                    title="Archivo de Presupuesto de Ventas"
                                    form={form}
                                    fieldName="salesBudgetFile"
                                    placeholder="Subir archivo..."
                                    singleFile
                                    onBlur={() => feature.importSalesBudgetFile()}
                                />
                            </Grid>
                        </Grid>
                    </FormSection>

                    <FormSection header={sectionHeader("Inflación por Categorías", "/templates/Template_Inflacion_Categorias.xlsx")}>
                        <Grid container gap={10}>
                            <Grid item xs={10} sm={5}>
                                <FormFileField
                                    key="inflationCategoryGroupsFile"
                                    title="Archivo de Inflación por Categorías"
                                    form={form}
                                    fieldName="inflationCategoryGroupsFile"
                                    placeholder="Subir archivo..."
                                    singleFile
                                    onBlur={() => feature.importInflationCategoryGroups()}
                                />
                            </Grid>
                        </Grid>
                    </FormSection>
                </Box>
            </Box>
        );
    };

    return (
        <LayoutContentWrapper isLoading={!isFeatureReady(feature)} renderContent={() => budgetContent()}/>
    );
}

export default observer(BudgetScreen);
